import { Reducer } from 'redux';
import {
  IAdvertisementTelevision,
  IAdvertisementTelevisionActionTypes,
} from './Types';

const initialAdvertisementTelevision: IAdvertisementTelevision = {
  result: null,
  isLoading: false,
  error: '',
};

const reducer: Reducer<IAdvertisementTelevision> = (
  state = initialAdvertisementTelevision,
  action
) => {
  switch (action.type) {
    case IAdvertisementTelevisionActionTypes.GET_AD_TV: {
      return {
        ...state,
        isLoading: true,
        error: '',
        result: null,
      };
    }
    case IAdvertisementTelevisionActionTypes.GET_AD_TV_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        result: null,
      };
    }
    case IAdvertisementTelevisionActionTypes.GET_AD_TV_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: '',
        result: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as AdvertisementTelevisionReducer };
